<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <SectionGroup
          v-for="(section, index) in formSchemaStore"
          :key="section.key"
          :section="section"
          :index="index + 1"
          :duplicateFlg="duplicateFlg"
          class="mb-5"
        />
      </v-col>
      <v-col cols="auto ml-4">
        <FormMenuToolBar />
      </v-col>
    </v-row>
    <MoveSectionModal
      :visible="showMoveSectionsModal"
      :sections="formSchemaStore"
      @close="toggleMoveSectionsModal(false)"
    />
    <!-- <CodeEditorModal :visible="showCodeEditorModal" :sections="formSchemaStore" @close="toggleCodeEditorModal(false)" /> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import SectionGroup from "./SectionGroup.vue";
import FormMenuToolBar from "./FormMenuToolBar.vue";
import "@/assets/styles/form-editor.less";
import { TOGGLE_MOVE_SECTION_MODAL, TOGGLE_CODE_EDITOR_MODAL } from "@/store/mutation-types";
import MoveSectionModal from "./MoveSectionModal.vue";
// import CodeEditorModal from "./CodeEditorModal.vue";

export default Vue.extend({
  props: {
    duplicateFlg: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      showMoveSectionsModal: (state) => (state).formEditor.showMoveSections,
      showCodeEditorModal: (state) => (state).formEditor.showCodeEditor,
      formSchemaStore: state => state.formEditor.formSchema,
      isMemberForm(state) {
        return (state).formEditor.formType === "member";
      },
    }),
  },
  components: { 
    SectionGroup, 
    FormMenuToolBar, 
    MoveSectionModal, 
    // CodeEditorModal 
  },
  methods: {
    ...mapMutations({
      toggleMoveSectionsModal: TOGGLE_MOVE_SECTION_MODAL,
      toggleCodeEditorModal: TOGGLE_CODE_EDITOR_MODAL,
    }),
  },
});
</script>